import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useFormContext } from 'react-hook-form';
import { useParams } from 'react-router-dom';
import PropTypes from 'prop-types';
import { getLanguage } from 'utils/cookies';
import FormTitle from 'components/IncorporationOfTerms/Register/FormAtoms/FormTitle';
import * as termsActions from 'redux/ducks/Terms/TermsDucks';
import TermsContents from './TermsContents';

export const Terms = ({ compAdminYn, reAgreementYn }) => {
  const dispatch = useDispatch();
  const { residenceCntry, termsContents } = useSelector(state => state.terms);

  const { setValue, getValues } = useFormContext();
  const { menu } = useParams();
  const langCd = getLanguage();

  useEffect(() => {
    const payload = { langCd, cntryCd: `${residenceCntry.value}`, compAdminYn, reAgreementYn };
    dispatch(termsActions.getCountryTerms(payload));
  }, [residenceCntry]);

  useEffect(() => {
    termsContents.map(item => {
      setValue(item.trmsCd, false, { shouldValidate: true });
    });
  }, [termsContents]);

  const handleOnShow = code => {
    setValue(code, !getValues(code));
  };

  return (
    <div className="form-section">
      {menu === 'admin' && (
        <>
          <FormTitle title="MB_T_ADMIN_TERM_SERVICE" />
          <ul className="term-table">
            <TermsContents name="SVCR" handleOnShow={handleOnShow} addBackground />
          </ul>
        </>
      )}
      {compAdminYn && (
        <>
          {menu !== 'reagreement' && <FormTitle title="MB_T_TERM_SERVICE" />}
          <ul className="term-table">
            {residenceCntry.value !== 'KR' && <TermsContents name="POAR" handleOnShow={handleOnShow} />}
            <TermsContents name="PIAR" handleOnShow={handleOnShow} />
            <TermsContents name="CMAR" handleOnShow={handleOnShow} isOnlyCheck />
          </ul>
        </>
      )}
    </div>
  );
};

Terms.propTypes = { compAdminYn: PropTypes.bool, reAgreementYn: PropTypes.bool };
Terms.defaultProps = { compAdminYn: false, reAgreementYn: false };

export default Terms;
